import { rgba } from 'polished'
import styled from 'styled-components'

import { IAccountDetailsUserCardStyles } from './AccountDetailsUserCard'
import { ClinTheme } from '../../../ClinTheme'
import { mediaQueryDown } from '../../../utils/mediaQuery'
import { ClinText } from '../../../components/ClinText'

interface StyledUserCardContentItemProps {
  paddingRight?: boolean
  paddingLeft?: boolean
  borderRight?: boolean
}

const tabletBreakpoint = ClinTheme.breakpoints[2]

export const StyledUserCardRow = styled.div({
  padding: `${ClinTheme.space[4]}px 0`,
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.grey}`
})

export const StyledUserCard = styled.div<IAccountDetailsUserCardStyles>(
  {
    [`${StyledUserCardRow}:last-of-type`]: {
      borderBottom: 'none',
      paddingBottom: '0'
    }
  },
  ({ isPending }) => ({
    background: isPending ? ClinTheme.colors.greyIndigo : ClinTheme.colors.white
  })
)

export const StyledUserCardHeader = styled.div({
  display: 'flex',
  width: '100%',
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.grey}`,
  padding: ClinTheme.space[3],
  boxSizing: 'border-box'
})

export const StyledUserCardProfile = styled.div({
  display: 'flex'
})

export const StyledUserCardProfileAvatar = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#FFBDA2',
  borderRadius: '50%',
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[1],
  textTransform: 'uppercase',
  height: ClinTheme.space[5],
  width: ClinTheme.space[5],
  minWidth: ClinTheme.space[5],
  fontWeight: ClinTheme.fontWeights.bolder,
  textAlign: 'center',
  lineHeight: 1,
  marginRight: ClinTheme.space[3]
})

export const StyledUserCardHeaderAction = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: ClinTheme.space[0],
  height: '40px',

  [mediaQueryDown(tabletBreakpoint)]: {
    position: 'relative',
    left: '-48px',
    width: 'calc(100% + 48px)',
    height: '40px',
    button: {
      flex: 1
    }
  },

  button: {
    height: '100%'
  }
})

export const StyledLoadingOverlay = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: rgba(ClinTheme.colors.white, 0.8),
  zIndex: ClinTheme.zIndices.confirmation
})

export const StyledUserCardContent = styled.div({
  display: 'flex',
  padding: ClinTheme.space[3],

  [mediaQueryDown(tabletBreakpoint)]: {
    flexDirection: 'column'
  }
})

export const StyledUserCardContentItem =
  styled.div<StyledUserCardContentItemProps>(
    ({ paddingRight, paddingLeft, borderRight }) => ({
      flex: '1',
      paddingRight: paddingRight ? ClinTheme.space[4] : '0',
      paddingLeft: paddingLeft ? ClinTheme.space[4] : '0',
      borderRight: borderRight
        ? `1px solid ${ClinTheme.colors.midGrey}`
        : 'none',

      [mediaQueryDown(tabletBreakpoint)]: {
        border: 'none',
        padding: ClinTheme.space[0],

        '&:not(:last-child)': {
          marginBottom: ClinTheme.space[5]
        }
      }
    })
  )

export const StyledRow = styled.div({
  '&:not(:last-child)': {
    marginBottom: ClinTheme.space[3]
  }
})

export const StyledColTitle = styled(ClinText)({
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[1],
  fontWeight: ClinTheme.fontWeights.bold,
  marginBottom: ClinTheme.space[3],
  lineHeight: '20px',
  letterSpacing: 0
})

export const StyledRowTitle = styled(ClinText)({
  color: ClinTheme.colors.darkGrey,
  fontSize: ClinTheme.fontSizes[0],
  fontWeight: ClinTheme.fontWeights.medium,
  lineHeight: '18px',
  letterSpacing: 0
})

export const StyledRowText = styled.div({
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[1],
  fontWeight: ClinTheme.fontWeights.medium,
  lineHeight: '20px',
  letterSpacing: 0,
  padding: 0
})

export const StyledUserName = styled(ClinText)({
  position: 'relative',
  fontWeight: ClinTheme.fontWeights.medium,
  color: ClinTheme.colors.primaryLight,
  paddingLeft: ClinTheme.space[2],

  '&::before': {
    content: '"•"',
    position: 'absolute',
    top: 0,
    left: '-7px'
  }
})

export const StyledUserCardHeaderInfo = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  gap: ClinTheme.space[3],

  [mediaQueryDown(tabletBreakpoint)]: {
    flexDirection: 'column'
  }
})
